module.exports = __webpack_public_path__ + "braveuistatic/img/apps/www.bravenet.com/src/assets/img/guestbooks/bravenet_guestbooks_responsive_design.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.bravenet.com/src/assets/img/guestbooks/bravenet_guestbooks_responsive_design.png
// module id = Vic9
// module chunks = 0